import { render } from "./p-slider.vue?vue&type=template&id=2c409c24&scoped=true"
import script from "./p-slider.vue?vue&type=script&lang=js"
export * from "./p-slider.vue?vue&type=script&lang=js"

import "./p-slider.vue?vue&type=style&index=0&id=2c409c24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c409c24"],['__file',"src/components/p-slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c409c24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c409c24', __exports__)) {
    api.reload('2c409c24', __exports__)
  }
  
  module.hot.accept("./p-slider.vue?vue&type=template&id=2c409c24&scoped=true", () => {
    api.rerender('2c409c24', render)
  })

}


export default __exports__